import axios from '../../../http';
import router from '../../../routes';

const state = {
  isEconomy7: false,
  tariffDetails: [],
  supplierTosUrl: '',
  supplierId: 0,
  tariffName: null,
  supplierName: null,
  payMethod: 'MonthlyDirectDebit'
};

const getters = {
  notDirectDebit: (state) => {
    const directDebits = ['MonthlyDirectDebit', 'QuaterlyDirectDebit'];

    return directDebits.indexOf(state.payMethod) < 0;
  }
};

const actions = {
  async get({ rootState, commit, dispatch }) {
    const { switchKey } = rootState.storage;
    const { switchType } = rootState.storage.quote;
    const fuelTypes = {
      gasToGas: 'Gas',
      electricityToElectricity: 'Electricity',
      dualDistinctToDualConsolidated: 'Gas & Electricity',
      dualConsolidatedToDualConsolidated: 'Gas & Electricity'
    };

    try {
      const { status, data } = await axios({
        method: 'POST',
        url: '/request/switch/pro/info/switch-plan',
        data: { switchKey }
      });

      if (status == 200) {
        const switchPlanInfoDto = data.geniusSwitchPlanInfoDto.geniusSwitchPlanInfo.switchPlanInfoDto;

        if (switchType == 'gasToGas') {
          switchPlanInfoDto.gas.fuelTitle = fuelTypes[switchType];
          commit('updateState', switchPlanInfoDto.gas);
        } else if (switchType == 'electricityToElectricity') {
          switchPlanInfoDto.electricity.fuelTitle = fuelTypes[switchType];
          commit('updateState', switchPlanInfoDto.electricity);
        } else {
          switchPlanInfoDto.electricity.fuelTitle = fuelTypes[switchType];
          switchPlanInfoDto.electricity.gasCost = switchPlanInfoDto.gas.cost;
          switchPlanInfoDto.electricity.gasSavings = switchPlanInfoDto.gas.savings;
          commit('updateState', switchPlanInfoDto.electricity);
        }
      }
    } catch (error) {
      // 401 / 500 / 502 already routed to ErrorPage by the HTTP interceptor
      const status = error && error.status;
      if (status === 401 || status === 500 || status === 502) {
        return;
      }

      // Route is named currentTariffCustomer (needs customerId); fall back to results
      const quote = (rootState.storage && rootState.storage.quote) || {};
      const customerId = quote.switchOwnerReference || quote.customerId || quote.switchId;

      if (customerId) {
        router.push({
          name: 'currentTariffCustomer',
          params: { customerId: String(customerId) }
        });
      } else {
        router.push({ name: 'quoteResults' });
      }
    }
  },
  async completeSwitch({ dispatch, rootState }) {
    const { switchKey } = rootState.storage;

    try {
      const { status, data } = await axios({
        method: 'POST',
        url: '/request/switch/pro/complete',
        data: { switchKey, switchCompleteOption: 'None' }
      });

      if (status == 200) {
        await dispatch('storage/save', {
          prop: 'switched',
          value: {
            referenceNumber: data.geniusSwitchedDto.referenceNumbers.g || data.geniusSwitchedDto.referenceNumbers.e,
            name: `${data.geniusSwitchedDto.title} ${data.geniusSwitchedDto.firstName} ${data.geniusSwitchedDto.lastName}`,
            supplierName: data.geniusSwitchedDto.supplier
          }
        }, { root: true });
        await dispatch('storage/save', {
          prop: 'uuid',
          value: data.geniusSwitchedDto.uuid
        }, { root: true });

        router.push({ name: 'switchComplete' });
      } else {
        throw 'switch';
      }
    } catch (error) {
      throw 'switch';
    }
  },
  async switched({ dispatch, rootState }) {
    const { quote } = rootState.storage;

    try {
      const { data } = await axios({
        method: 'POST',
        url: '/request/customer/whitelabel/switch/complete',
        data: { switchId: quote.switchId }
      });

      if (data) {
        await dispatch('storage/save', {
          prop: 'alreadySwitched',
          value: true
        }, { root: true });

        router.push({ name: 'switchComplete' });
      }

      return data;
    } catch (error) {
      return false;
    }
  }
};

const mutations = {
  updateState(state, value) {
    state = Object.assign(state, value);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
